import React from "react";
import classes from "./ButtonActions.module.scss";
import { Button } from "antd";

const ButtonActions = ({
  text,
  onClick,
  variant = "outline",
  disabled = false,
  loading = false,
  htmlType = "button",
  icon,
  style,
}) => {

  const buttonVariant = {
    outline: classes.outline,
    primary: classes.primary,
    danger: classes.danger,
  };

  return (
    <Button
      htmlType={htmlType}
      disabled={disabled}
      loading={loading}
      style={style}
      onClick={onClick}
      className={`${classes.button} ${buttonVariant[variant]}`}
    >
      {icon && icon}
      {text}
    </Button>
  );
};

export default ButtonActions;
